import { Box, CircularProgress } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { container } from 'tsyringe';
import HairCheck from '../../components/welcome-tutos/HairCheck';
import { ApiService } from '../../services/api-service';
import { PeopleService } from '../../services/people-service';
import { PTApiService } from '../../services/ptapi-service';
import { UserService } from '../../services/user-service';
import { WebRTCsdkService } from '../../services/webrtcsdk-service';
import { normalizeBJNSharingUrl } from '../../utils/helpers';
import { Channel } from '../channel/Channel';
import './Event.scss';

import Lottie from 'react-lottie-player';
import lottieLoadingStudioJson from '../../assets/lottie/loading-studio.json';

export enum EventSubpage {
    INIT,
    EVENT,
    HAIRCHECK
};

export const EventPage = () => {

    const { code } = useParams();

    const [userService] = useState(container.resolve(UserService));
    const [apiService] = useState(container.resolve(ApiService));
    const [ptApiService] = useState(container.resolve(PTApiService));
    const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));
    const [peopleService] = useState(container.resolve(PeopleService));
    const [error, setError] = useState('');
    const [page, setPage] = useState(EventSubpage.HAIRCHECK);
    const [channelId, setChannelId] = useState<string>(null);
    const [isLoadingEvent, setIsLoadingEvent] = useState(true);

    const joinEvent = useCallback(async () => {
        try {

            // await ptApiService.retrievePtUserToken();

            // Can save this http call if we pass this from /channel-select to /event page in auery parameters
            const evid = 'demodemo'; // (await ptApiService.getPublicEventFromCode(code)).eventId;
            const [publicEvent, eventDetails] = await ptApiService.connectToEvent(evid, code);

            await peopleService.initialize();
            // await webRTCsdkService.joinMeeting(eventDetails.meetingNumericId, eventDetails.moderatorPasscode, userService.user.firstName);

            // let instanceId = publicEvent.instanceId;
            // if (!instanceId) {
            //     instanceId = await ptApiService.waitForEventInstanciated();
            // }

            let channel: any = {
                uuid: 'demo-demo-demo-demo',
                eventStatus: 'NEW',
            }
            //await apiService.getChannelByEventId(evid, instanceId);

            // if (channel && !['NEW', 'LIVE', 'TERMINATED'].includes(channel.eventStatus)) {
            //     await apiService.deleteChannel(channel.uuid);
            //     channel = null;
            // }

            // if (!channel) {
            //     // Create channel from BJ event
            //     channel = await apiService.createChannel({
            //         name: publicEvent.eventTitle,
            //         meetingProperties: {
            //             meetingId: eventDetails.meetingNumericId,
            //             meetingPassCode: eventDetails.moderatorPasscode,
            //             moderatorUrl: normalizeBJNSharingUrl(publicEvent.joinUrl),
            //             ptEventId: evid,
            //             ptEventInstanceId: instanceId,
            //             roster: []
            //         }
            //     });
            // }

            setChannelId(channel.uuid);
            setTimeout(() => {
                setPage(EventSubpage.EVENT);
                setIsLoadingEvent(false);

            }, 100);
        } catch (e) {
            console.error(e);
            // setError(`${e?.message || e}`);
        } finally {
            // setIsLoadingEvent(false);
        }
    }, [code]);

    return <>
        {page === EventSubpage.INIT && <div>
            {error && <Box padding={3} textAlign="center">
                An error occurred: {error}
            </Box>}
            {!error && <Box padding={3}>
                <h3>Hello {userService.user?.firstName}! Please wait, we are preparing your event...</h3>
                <Box display="flex" width="100%" alignItems="center" marginTop="30%" justifyContent="center">
                    <CircularProgress />
                </Box>
            </Box>}
        </div>
        }
        {page === EventSubpage.HAIRCHECK && <HairCheck channelReady={false} goToPage={p => joinEvent()}></HairCheck>}
        {page === EventSubpage.EVENT && <Channel channelId={channelId} goToPage={p => setPage(p)}></Channel>}

        {isLoadingEvent && <div className="app-connecting-background">
            <div className="app-connecting-popup">

                <Lottie loop animationData={lottieLoadingStudioJson} play style={{ width: "110px", height: "110px", color: "#818181", marginLeft: 'auto', marginRight: 'auto', marginTop: '25px' }} />
                <div className="app-connecting-popup-title">
                    Welcome to BlueJeans Studio!
                </div>
                <div className="app-connecting-popup-title2">
                    Connecting to Studio….
                </div>
                <div className="app-connecting-popup-tips">
                    Please wait a few seconds while we set studio up for you!
                </div>
            </div>
        </div>}
    </>

}